import { ADColumnType } from '@/shared/model/ad-column.model';
import { IADField } from '@/shared/model/ad-field.model';
import { Component, Vue, Watch } from 'vue-property-decorator';
import settings from '@/settings';

const AdInputDateProps = Vue.extend({
  props: {
    disabled: Boolean,
    fieldMeta: Object,
    value: [Date, String],
  },
});

@Component
export default class AdInputDate extends AdInputDateProps {
  date: string = null;

  get datePickerType() {
    const field = this.fieldMeta as IADField;
    const type = field.type || field.adColumn?.type;
    return type === ADColumnType.LOCAL_DATE ? 'date' : 'datetime';
  }

  get formattedDisplay() {
    const field = this.fieldMeta as IADField;
    const type = field.type || field.adColumn.type;
    return type === ADColumnType.LOCAL_DATE ? settings.dateDisplayFormat : settings.dateTimeDisplayFormat;
  }

  get formattedValue() {
    const field = this.fieldMeta as IADField;
    const type = field.type || field.adColumn.type;
    return type === ADColumnType.LOCAL_DATE ? settings.dateValueFormat : settings.dateTimeValueFormat;
  }

  @Watch('value')
  onValueChanged(value: string) {
    if (this.date !== value) {
      this.date = value;
    }
  }

  onChanged(value: string) {
    this.$emit('change', value);
  }

  onInput(value: string) {
    this.$emit('input', value);
  }

  created() {
    this.date = this.value;
  }
}
